import { render, staticRenderFns } from "./menuItem.vue?vue&type=template&id=2e5958a4&scoped=true"
import script from "./menuItem.vue?vue&type=script&lang=js"
export * from "./menuItem.vue?vue&type=script&lang=js"
import style0 from "./menuItem.vue?vue&type=style&index=0&id=2e5958a4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5958a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e5958a4')) {
      api.createRecord('2e5958a4', component.options)
    } else {
      api.reload('2e5958a4', component.options)
    }
    module.hot.accept("./menuItem.vue?vue&type=template&id=2e5958a4&scoped=true", function () {
      api.rerender('2e5958a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aiChat/components/sidebar/components/menuItem.vue"
export default component.exports